import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import HeaderIconButton from "./HeaderIconButton";
const HeaderCartButton = (props) => {
    let { quantity } = useSelector((state) => state.cart);
    return _jsx(HeaderIconButton, { ...props, number: quantity, hideNumber: props.hideNumber });
};
export default HeaderCartButton;
